import joi from 'joi';
import { i18n } from 'i18next';
import { validateWithTranslations } from '../utils';

export async function uploadFileValidation(
  file: File,
  i18n: i18n,
): Promise<[true, undefined] | [false, string]> {
  const schema = joi.object({
    file: joi
      .any()
      .custom((value, helpers) => {
        if (value && !['image/jpg', 'image/jpeg', 'image/png'].includes(value.type)) {
          return helpers.error('custom.fileType');
        }
        return value;
      })
      .custom((value, helpers) => {
        if (value && value.size > 1048576) {
          return helpers.error('custom.fileSize');
        }
        return value;
      }),
  });

  try {
    const { error } = validateWithTranslations({ file }, schema, i18n);
    if (error) {
      return [false, error.message];
    }
    return [true, undefined];
  } catch (error: any) {
    return [false, error.message];
  }
}
